module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/list-3f7c3d9b22a7ad7094004d9afa2c2bfb.svg";